window.directionsMap = function directionsMap() {
    'use strict';

    var directions_element,
        map_redesign;

    if ($(window).width() <= window.breakpoints.mobile) {
        directions_element = $('');
        $('.addressSearch .button').on('click', function () {
            $('.viewOnGoogleMaps.mobile').show();
        });
    } else {
        directions_element = $('');
        $('.addressSearch .button').on('click', function () {
            $('.viewOnGoogleMaps.desktop').show();
        });
    }

    if ($('.dealershipPageWrapRedesign').length) {
        map_redesign = true;
    } else {
        map_redesign = false;
    }

    $(".js_map").mtcGoogleMaps({
        search: {
            search_form: '.addressSearch',
            get_directions: true,
            directions_element: directions_element,
            map_redesign: map_redesign
        }
    });

}